import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./ValidationError.module.less";

export type ValidationErrorProps = {
	message: string | undefined;
	trackingId?: string;
};

export const ValidationError = (props: ValidationErrorProps): ReactElement => {
	const {
		message,
		trackingId
	} = props;

	return (
		<>
			{ message && (
				<span className={styles.root} {...setTrackingId(trackingId)}>{message}</span>
			)}
		</>
	);
};
ValidationError.displayName = "ValidationError";
